import { useState, useEffect, useRef } from "react";
import { categories } from "@/mocks/categories";

export default function Hero() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20sophisticated%20flat%20lay%20fashion%20photography%20featuring%20a%20luxury%20watch%20premium%20leather%20sneakers%20designer%20sunglasses%20and%20a%20silk%20scarf%20arranged%20on%20a%20deep%20charcoal%20backdrop%20with%20dramatic%20golden%20lighting%20from%20the%20side%20creating%20rich%20shadows%20and%20texture%20magazine%20editorial%20quality%20elevated%20product%20photography&width=1800&height=1200&seq=hero-main-bg-v03&orientation=landscape"
          alt="Kakobuy Spreadsheet - Baza produktów"
          className="w-full h-full object-cover object-top"
          title="Kakobuy Spreadsheet - Najlepsza Baza Produktów"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-[1400px] mx-auto">
        <div className="flex flex-col items-start max-w-2xl">
          <h1 className="text-white font-heading font-bold text-5xl md:text-7xl lg:text-8xl leading-[1.05] mb-6">
            Kakobuy<br />Spreadsheet
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-lg mb-10 leading-relaxed">
            Odkryj setki zweryfikowanych produktów — od sneakersów po akcesoria. Codzienna aktualizacja, bezpieczne linki i pełna ochrona kupującego.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-6 py-3 rounded-full border-2 border-white/40 text-white font-semibold text-sm hover:border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                Wybierz Kategorię
                <i className={`ri-arrow-down-s-line text-lg transition-transform ${dropdownOpen ? "rotate-180" : ""}`}></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full mt-2 left-0 bg-background-50 rounded-xl border border-background-200 shadow-xl py-3 w-64 max-h-[380px] overflow-y-auto z-50">
                  {categories.map((cat) => (
                    <a
                      key={cat.id}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-5 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-base text-primary-500`}></i>
                      </span>
                      {cat.namePl}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 rounded-full bg-white text-foreground-950 font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none select-none">
        <p className="text-white/10 font-heading font-extrabold text-[120px] md:text-[160px] leading-none whitespace-nowrap">
          Kakobuy Spreadsheet
        </p>
      </div>
    </section>
  );
}